import {Injectable, Injector} from '@angular/core';
import {ApiService} from '@abstract/api.service';
import {map} from 'rxjs/operators';
import {Observable} from 'rxjs';
import {EquipmentListResponse} from '@components/equipment-select/equipment-select.component';
import {WizardInterfaces} from '../../../wizard.namespace';
import {EquipmentDataService} from '../equipment-data.service';
import {HttpClient} from '@angular/common/http';
import {ErrorLoggerService} from '@services/error-logger.service';

@Injectable()
export class EquipmentSearchService extends ApiService {
    baseUrl = 'apparatus/wizard-filter';

    constructor(
        http: HttpClient,
        logger: ErrorLoggerService,
        injector: Injector,
        private dataService: EquipmentDataService,
    ) {
        super(http, logger, injector);
    }

    /**
     * Метод используется, но инжектируется неочевидно, нужно оставить
     * @param title
     * @param page
     */
    getEquipment(title: string = '', page: number = 1): Observable<EquipmentListResponse> {

        const group = this.dataService.group$.getValue();
        const attestation: WizardInterfaces.AttestationValue = this.dataService.attestation$.getValue();

        return this.post({
            dataBody: {
                group_id: group ? group.id : null,
                method_id: this.dataService.methodId$.getValue(),
                object_ids: attestation ? attestation.objects.map(o => +o.id) : [],
                submethods_ids: attestation ? attestation.submethods.map(s => +s.id) : [],
                is_reference: this.dataService.isReference$.getValue(),
                title,
                items_per_page: 7,
                page,
            }
        }).pipe(
            map((v: WizardInterfaces.EquipmentSearchResponce) => {
                return {
                    total_items_count: v.total_items_count,
                    total_found_count: null,
                    items: v.items || [],
                    page: v.page || 1,
                    pages_total: v.pagesTotal || 1,
                };
            })
        );
    }
}
